// extracted by mini-css-extract-plugin
export default {"goals":"Goals_goals__n-yoh","header":"Goals_header__5jF+C","row":"Goals_row__XumA0","select":"Goals_select__buAA+"};